import userGuide from '@/components/userGuide/index';
import UserGuideOverview from '@/components/userGuide/overview';
import UserGuideCrossTabulation from '@/components/userGuide/crossTabulation';
import UserGuideDataAnalysisFaq from '@/components/userGuide/dataAnalysisFaq';
import UserGuideLogisticRegression from '@/components/userGuide/logisticRegression';
import UserGuideVariables from '@/components/userGuide/variables';

export default {
    routes: [
        // { path: '/help/overview', name: 'helpOverview', component: UserGuideOverview },
        { path: '/help/crossTabulation', name: 'helpCrossTabulation', component: UserGuideCrossTabulation },
        { path: '/help/dataAnalysisFaq', name: 'helpDataAnalysisFAQ', component: UserGuideDataAnalysisFaq },
        { path: '/help/logisticRegression', name: 'helpLogisticRegression', component: UserGuideLogisticRegression },
        { path: '/help/variables', name: 'helpVariables', component: UserGuideVariables },
        { path: '/help', name: 'help', component: userGuide },
        { path: '/help/:index?', name: 'helpIndex', component: userGuide },

        { path: '/userGuide', name: 'userGuide', component: userGuide },
        {
            path: '/userGuide/index',
            name: 'userGuideIndex',
            component: userGuide
        },
        // { path: '/userGuide/overview', name: 'userGuideOverview', component: UserGuideOverview },
        { path: '/userGuide/crossTabulation', name: 'userGuideCrossTabulation', component: UserGuideCrossTabulation },
        { path: '/userGuide/dataAnalysisFaq', name: 'userGuideDataAnalysisFAQ', component: UserGuideDataAnalysisFaq },
        { path: '/userGuide/logisticRegression', name: 'userGuideLogisticRegression', component: UserGuideLogisticRegression },
        { path: '/userGuide/variables', name: 'userGuideVariables', component: UserGuideVariables }
    ]
}
